import { BrowserProvider } from "ethers";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {  useNavigate } from "react-router-dom";
import { MetaMask_Fox, trustWalletNew, walletConnectNew } from "../../assets";
import { useSyncProviders } from "../../hooks/useSyncProvider";
import {
  setAccount,
  setCurrentDisplay,
  setIsMetaMaskConnected,
  setIsWalletConnect,
  setProvider,
} from "../../redux/wallet/walletSlice";
import { balanceOfFromContract } from "../../uniswap/utils";
import { BootstrapDialog } from "../newBuyNode/components/NodeModal";
import CloseModalButton from "./components/CloseWalletButton";
import ConnectItem from "./components/ConnectItem";
import ConnectionRecommendations from "./components/ConnectionRecommendations";

const WalletModal = ({ isWalletOpen, closeModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const providers = useSyncProviders();
  const [nodesCount, setNodesCount] = useState(0);
  const nodes = localStorage.getItem("nodeCount");
  const fetchNodesCount = async (account) => {
    try {
      console.log("Fetching nodes count...");
      const count = await balanceOfFromContract(account);

      setNodesCount(Number(count));

      localStorage.setItem("nodeCount", count);
    } catch (error) {
      console.error("Failed to fetch nodes count", error);
    }
  };
  const handleWalletConnect = async () => {

  };

  const handleMetamask = async (providers) => {
    try {
      closeModal();
      const providerWithInfo = providers.find(
        (provider) => provider.info.name === "MetaMask"
      );

      if (!providerWithInfo) {
        toast.error("You don't have MetaMask installed", { duration: 1000 });
        return;
      }
      const accounts = await providerWithInfo.provider.request({
        method: "eth_requestAccounts",
      });

      const ethersProvider = new BrowserProvider(
        await providerWithInfo.provider
      );

      const providerData = {
        network: Number((await ethersProvider.getNetwork()).chainId),
      };

      dispatch(setProvider(providerData));
      dispatch(setAccount(await accounts[0]));
      dispatch(setCurrentDisplay(await accounts[0]));
      dispatch(setIsMetaMaskConnected(true));
      dispatch(setIsWalletConnect(true));

      localStorage.setItem("connectedAccount", accounts[0]);
      localStorage.setItem("isWallet", "true");
      localStorage.setItem("walletName", "MetaMask");

      const connectedAccount = localStorage.getItem("connectedAccount");
      await fetchNodesCount(connectedAccount);
    } catch (error) {
      console.error("Error checking MetaMask connection:", error);
    }
  };

  const handleTrustWallet = async (providers) => {
    try {
      closeModal();
      const providerWithInfo = providers.find(
        (provider) => provider.info.name === "Trust Wallet"
      );

      if (!providerWithInfo) {
        toast.error("You don't have Trust Wallet installed", {
          duration: 1000,
        });
        return;
      }

      const accounts = await providerWithInfo.provider.request({
        method: "eth_requestAccounts",
      });

      const ethersProvider = new BrowserProvider(
        await providerWithInfo.provider
      );

      const providerData = {
        network: Number((await ethersProvider.getNetwork()).chainId),
      };

      dispatch(setProvider(providerData));
      dispatch(setAccount(accounts[0]));
      dispatch(setCurrentDisplay(accounts[0]));
      dispatch(setIsMetaMaskConnected(false));
      dispatch(setIsWalletConnect(true));

      localStorage.setItem("connectedAccount", accounts[0]);
      localStorage.setItem("isWallet", "true");
      localStorage.setItem("walletName", "Trust Wallet");

      const connectedAccount = localStorage.getItem("connectedAccount");
      await fetchNodesCount(connectedAccount);
    } catch (error) {
      console.error("Error checking Trust Wallet connection:", error);
    }
  };

  const connectToMetaMask = () => {
    handleMetamask(providers);
  };
  const connectToTrustWallet = () => {
    handleTrustWallet(providers);
  };

  return (
    <BootstrapDialog open={isWalletOpen} onClose={closeModal}>
      <div
        className={
          "font-inter max-w-140 md:w-140 bg-white rounded-3xl shadow-smallShadow dark:bg-[#1D1C2D]"
        }
      >
        <div className="py-4 px-6 md:px-8 md:py-6 items-center md:items-start  w-full flex justify-between border-b border-lightGrayBlue dark:border-darkSlateBlue">
          <h3 className="font-bold text-black dark:text-white text-xl md:text-2xl leading-9">
            Connect Wallet
          </h3>
          <CloseModalButton closeModal={closeModal} />
        </div>
        <div className="flex flex-col gap-4 px-[8px] xs:px-4 md:px-8 pt-3 pb-8 lg:border-b border-lightGrayBlue dark:border-darkSlateBlue">
          <ConnectItem
            onHandleClick={connectToMetaMask}
            walletName={"Metamask"}
            imgName={"Fox icon"}
            imgLink={MetaMask_Fox}
          />
          <ConnectItem
            onHandleClick={connectToTrustWallet}
            walletName={"Trust Wallet"}
            imgName={"trust - shield icon"}
            imgLink={trustWalletNew}
          />
          <ConnectItem
            onHandleClick={handleWalletConnect}
            walletName={"Wallet Connect"}
            imgName={"wallet"}
            imgLink={walletConnectNew}
          />
        </div>
        <div className="hidden lg:block px-8 pt-3 pb-8">
          <ConnectionRecommendations />
        </div>
      </div>
    </BootstrapDialog>
  );
};

export default WalletModal;
